var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('div',{staticClass:"auth__container"},[_c('router-view',{key:_vm.$route.path})],1):_c('LoaderComponent',{attrs:{"value":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }